import React from 'react';

/**
 * PolicyFooter — Pie de página legal mínimo
 * Aparece en la página de login y al fondo del área autenticada.
 * Pequeño, semitransparente, no invasivo.
 */
const PolicyFooter = () => (
  <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 py-4 text-[10px] text-gray-700 select-none">
    <a
      href="/terms"
      className="hover:text-gray-500 transition-colors duration-200"
    >
      Términos de Servicio
    </a>
    <span className="text-gray-800">·</span>
    <a
      href="/privacy"
      className="hover:text-gray-500 transition-colors duration-200"
    >
      Política de Privacidad
    </a>
    <span className="text-gray-800">·</span>
    <a
      href="/refund"
      className="hover:text-gray-500 transition-colors duration-200"
    >
      Política de Reembolso
    </a>
    <span className="text-gray-800">·</span>
    <span className="text-gray-800">© 2026 IntelliVerseOne</span>
  </div>
);

export default PolicyFooter;
